import * as TYPES from '../../store/types'

const state = {
  materials: [],
  metadata: {},
  readOnly: false,
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.MATERIALS_SET_DATA](st, obj) {
    if (obj.materials) {
      st.materials = obj.materials
    }

    if (obj.metadata) {
      st.metadata = obj.metadata
    }

    st.readOnly = !!obj.readOnly
  },
}

const actions = {
  materialsSetData({ commit }, obj) {
    commit(TYPES.MATERIALS_SET_DATA, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
